import React from "react";
import MobileNav from "./MobileNav";
import DesktopNav from "./DesktopNav";

const Navbar = () => {
  return (
    <header>
      <section className="block lg:hidden">
        <MobileNav />
      </section>
      <DesktopNav />
    </header>
  );
};

export default Navbar;
